
import { AccessToken, SubscriptionRecord, IntegrationFlow, AgentProfile, ServiceDefinition, IntegrationApp, Conversation, Plan } from '../types';
import { SERVICES_DATA, INTEGRATION_APPS_DATA, PLANS_DATA } from '../constants';

export const MOCK_TOKENS: AccessToken[] = [
  {
    id: 'mock_k1',
    name: 'Development Key',
    token: 'lahja_sk_standard_mock123xyz',
    type: 'standard',
    createdAt: Date.now() - 10000000,
    expiresAt: null,
    status: 'active'
  }
];

export const MOCK_SUBSCRIPTIONS: SubscriptionRecord[] = [
  {
    id: 'sub_mock_active',
    planId: 'pro',
    status: 'active',
    startDate: Date.now() - 1000 * 60 * 60 * 24 * 10,
    endDate: Date.now() + 1000 * 60 * 60 * 24 * 20,
    autoRenew: true,
    price: '49 SAR'
  }
];

export const MOCK_FLOWS: IntegrationFlow[] = [
  {
    id: 'flow_1',
    name: 'Auto-Reply Flow',
    active: true,
    nodes: [
        { id: '1', type: 'trigger', position: { x: 50, y: 150 }, data: { label: 'Message Received', subLabel: 'WhatsApp', icon: 'fa-whatsapp', config: { type: 'webhook' } } },
        { id: '2', type: 'ai_service', position: { x: 350, y: 150 }, data: { label: 'Sentiment Analysis', subLabel: 'AI Processor', icon: 'fa-brain', config: { serviceId: 'analytics' } } }
    ],
    edges: [{ id: 'e1-2', source: '1', target: '2' }]
  }
];

export const MOCK_AGENTS: AgentProfile[] = [
  {
    id: 'default-1',
    name: 'المساعد العام',
    role: 'خدمة عملاء',
    avatar: 'fa-robot',
    dialect: 'najdi',
    voice: 'Kore',
    systemPrompt: 'أنت مساعد ذكي ومفيد.',
    autoReply: true,
    voiceOutput: true,
    sensitivity: 0.5,
    stats: { interactions: 124, lastActive: 'Now' }
  }
];

export const MOCK_SERVICES: ServiceDefinition[] = SERVICES_DATA;

export const MOCK_INTEGRATIONS: IntegrationApp[] = INTEGRATION_APPS_DATA;

export const MOCK_PLANS: Plan[] = PLANS_DATA;

export const MOCK_CONVERSATIONS: Conversation[] = [
    {
        id: 'conv_1',
        title: 'محادثة تجريبية',
        updatedAt: Date.now(),
        dialect: 'najdi',
        messages: [
            { id: 'm1', role: 'assistant', content: 'هلا بك! كيف أقدر أخدمك اليوم؟', timestamp: Date.now() }
        ]
    }
];
